import React, { Suspense, lazy } from 'react';
import { canUseDOM } from '../../utils';
const StickyFooterLazyLoadedContent = /*#__PURE__*/lazy(() => import("./StickyFooterLazyLoadedContent"));
const SuspenseWrapper = props => {
  return /*#__PURE__*/React.createElement(Suspense, {
    fallback: /*#__PURE__*/React.createElement(React.Fragment, null)
  }, /*#__PURE__*/React.createElement(StickyFooterLazyLoadedContent, props));
};
const StickyFooter = props => {
  if (canUseDOM) {
    return /*#__PURE__*/React.createElement(SuspenseWrapper, props);
  } else {
    return /*#__PURE__*/React.createElement(React.Fragment, null);
  }
};
export default StickyFooter;